import { Component, Input, OnInit } from '@angular/core';
import { Inventory } from '@data/models/inventory.model';
import { User } from '@data/models/user.model';
import { WindowRefService } from '../../services/window-ref/window-ref.service';

@Component({
    selector: 'syn-header',
    templateUrl: 'header.component.html',
    styleUrls: ['header.component.scss'],
})
export class HeaderComponent implements OnInit {

    @Input() text: string;
    @Input() caption: string;
    @Input() tooltip: string;
    @Input() matIco: string;
    @Input() user: User;
    @Input() inventory: Inventory;
    @Input() actions: HeaderAction[] = [];
    @Input() menuActions: HeaderAction[] = [];

    public noHistory = true;

    constructor(
        private readonly winRef: WindowRefService,
    ) {}

    public ngOnInit(): void {
        this.noHistory = this.winRef.nativeWindow.history.length <= 1;
    }
}

export class HeaderAction {
    name: string;
    icon: string;
    route?: string;
    disabled?: boolean;
    loading?: boolean;
    tooltip?: string;
    superscript?: string;
    superscriptStyle?: {};
    style?: {};
    click?: () => void;
    target?: string;
    additional?: boolean;
}
